// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"id":"arrow-left-up"},"nodeName":"g","children":[{"attributes":{"id":"stroke1","stroke":"currentColor","d":"M15.7782 8L8 8L8 15.7782M8.87946 8.87946L16.0257 16.0257","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]}]}]};

@tag('t-icon-arrow-left-up')
export default class ArrowLeftUpIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'arrow-left-up',
    }
  }
}
